export type FileViewerKind = "pdf" | "image" | "other";

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];

export class FileViewerUtils {
  static getFileKind(fileNameOrUrl: string | null | undefined, fileType?: string | null): FileViewerKind {
    const mime = (fileType || "").toLowerCase();
    if (mime.includes("pdf")) return "pdf";
    if (mime.startsWith("image/")) return "image";

    const ext = FileViewerUtils.extractExtension(fileNameOrUrl || "");
    if (ext === "pdf") return "pdf";
    if (IMAGE_EXTENSIONS.includes(ext)) return "image";
    return "other";
  }

  private static extractExtension(value: string): string {
    const clean = value.split("?")[0].split("#")[0];
    const idx = clean.lastIndexOf(".");
    return idx >= 0 ? clean.slice(idx + 1).toLowerCase() : "";
  }
}
